import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = params.get("category") || "";

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: category ? { category } : {} }).then((r) => {
      setProducts(r.data); setLoading(false);
    });
  }, [category]);

  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);

  const visible = useMemo(() => products, [products]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid="shop-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
        <div>
          <div className="label-mono text-cyan-400 mb-3">/ CATALOG</div>
          <h1 className="text-4xl md:text-5xl font-medium tracking-tight">Research Peptides</h1>
          <p className="mt-3 text-slate-400 max-w-xl">All compounds research-use-only. Synthesized & verified in-house.</p>
        </div>
        <div className="font-mono text-xs text-slate-500" data-testid="results-count">
          {visible.length} compound{visible.length !== 1 && "s"}
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-8">
        <button
          onClick={() => setParams({})}
          data-testid="filter-all"
          className={`text-xs label-mono px-4 py-2 border transition ${!category ? "border-cyan-500 bg-cyan-500/10 text-cyan-400" : "border-white/10 text-slate-400 hover:border-cyan-500/30 hover:text-cyan-400"}`}
        >
          All
        </button>
        {categories.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
            onClick={() => setParams({ category: c })}
            className={`text-xs label-mono px-4 py-2 border transition ${category === c ? "border-cyan-500 bg-cyan-500/10 text-cyan-400" : "border-white/10 text-slate-400 hover:border-cyan-500/30 hover:text-cyan-400"}`}
          >
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-20 text-slate-500" data-testid="loading-state">Loading…</div>
      ) : visible.length === 0 ? (
        <div className="text-center py-20 text-slate-500">No products in this category.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {visible.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      )}
    </div>
  );
}
